// Inventory ticker configuration
// -------------------------------
// Controls the scrolling "available for immediate sale" bar at the bottom
// of the site (see components/InventoryTicker.vue).
//
// To HIDE the ticker entirely (e.g. the last batch sold), set `active: false`.
//   - When inactive, the bar never appears on any page.
//
// To CHANGE what scrolls, edit the `items` array below.
//   - Each item is one headline. Add as many as you like; they scroll in order.
//   - `text` is what shows. Use ` • ` to separate details within a single headline.
//   - `link` is optional. Set it to a URL (e.g. '/trailers') to make the
//     headline clickable, or leave it null for plain text.
//
// CLICK-TO-OPEN DETAIL POPUP (optional, per item):
//   - `images`: array of picture paths served from /public (e.g.
//     '/img/stock/stock1.jpg'). The first is the starting hero image; all of
//     them appear as selectable thumbnails. Omit or leave empty and the popup
//     shows a "No pictures available" placeholder instead.
//   - `detail`: the info shown beside the pictures:
//       { title?, heading?, specs: [ '...', '...' ], footer? }
//   An item that has `detail` or `images` becomes clickable and opens the popup
//   (this takes priority over `link`).
//
// Any edit here automatically counts as "the data changed": visitors who
// previously dismissed the ticker will see the new version again.

export const inventoryTicker = {
  active: true,
  items: [
    {
      text: '3-A Sanitary • 8000 gal • Transport • (12) • Can be modified with a Direct Ship cabinet • Call us for details!',
      link: null,
      images: [
        '/img/stock/stock2.jpg',
        '/img/stock/stock3.jpg',
        '/img/stock/stock4.jpg',
        '/img/stock/stock5.jpeg',
      ],
      detail: {
        heading: 'We currently have the following stock available in Beloit, WI',
        specs: [
          '8,000 gal',
          '3-A Sanitary',
          '(12)',
          'Ridewell or Hendrickson suspension options w/ disk brakes',
          'Transport (can be modified with a direct ship cabinet)',
          'Curbside ladder',
        ],
        footer: 'Call for more information',
      },
    },
  ],
}

export default inventoryTicker
